import { Route, Routes } from "react-router-dom";
import AddToCartPage from "./components for ikea/AddToCartPage/AddToCartPage";
import InitialDeliveryPage from "./components for ikea/InitialDeliveryPage/InitialDeliveryPage";
// import GridRow11 from "./components for ikea/GridRows(10-12)/GridRow11";

import SearchBar from "./components for ikea/SearchBar/SearchBar";


function App(props) {
  return (
    <Routes>
      <Route path="/" element={<SearchBar />}></Route>
      <Route path="/sale" element={<AddToCartPage/>}></Route>
      <Route path="/shoppingCart" element={<InitialDeliveryPage/>}></Route>

    </Routes>
    
      // <SearchBar />
    
  );
}

export default App;
